export async function loginWithPin(pin) {
    const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin }),
    });

    const data = await res.json();
    if (data.token) {
        localStorage.setItem('dj_token', data.token);
        return true;
    }

    return false;
}

export function getToken() {
    return localStorage.getItem('dj_token');
}
